import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import { useCallback } from 'react';

import { WorkbenchService } from '../../../modules/workbench';
import { notifyMovedToTrash } from '../../notify-moved-to-trash';

interface FolderTrashToastOptions {
  onUndo: () => void | Promise<void>;
}

export function useTrashFolderToast() {
  const t = useI18n();
  const workbench = useService(WorkbenchService).workbench;

  return useCallback(
    ({ onUndo }: FolderTrashToastOptions) => {
      notifyMovedToTrash({
        title: t['com.streamlain.movedToTrash.folder'](),
        undoLabel: t['Undo'](),
        openTrashLabel: t['com.streamlain.movedToTrash.openTrash'](),
        onUndo,
        onOpenTrash: () => {
          workbench.openTrash();
        },
      });
    },
    [t, workbench]
  );
}
